
























































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import {
    DEFAULT_NETWORK_ID,
    DEFAULT_NETWORK,
    DEFAULT_NETWORK_NAME,
} from '@/store/modules/network/network'

@Component({})
export default class Footer extends Vue {
    netID = DEFAULT_NETWORK_ID.toString()

    get selectedNet() {
        return this.$store.state.Network.selectedNetwork
    }

    generateURL(path: string) {
        const baseUrl = path // Base URL without query parameters
        const queryParams: { [network: string]: string } = {
            network: DEFAULT_NETWORK_NAME,
        } // Query parameters and their values

        // Generate the URL by appending the query parameters
        const url = new URL(baseUrl, window.location.origin)
        Object.keys(queryParams).forEach((key) => {
            url.searchParams.append(key, queryParams[key])
        })
        return url.toString()
    }

    @Watch('selectedNet')
    currentNetID() {
        if (this.selectedNet) this.netID = this.selectedNet.networkId
        else this.netID = DEFAULT_NETWORK_ID.toString()
    }

    get _actChainID() {
        return DEFAULT_NETWORK.actChainId
    }

    get _astChainID() {
        return DEFAULT_NETWORK.astChainId
    }

    get _athChainID() {
        return DEFAULT_NETWORK.athChainId
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    get actChainURL() {
        return `/action`
    }

    get astChainURL() {
        return `/blockchain/${this._astChainID}`
    }

    get athChainURL() {
        return `/blockchain/${this._athChainID}`
    }

    get statusPageURL() {
        return DEFAULT_NETWORK.statusUrl
    }

    get explorerURL() {
        return DEFAULT_NETWORK.actChainExplorerUrl
    }

    get walletURL() {
        return DEFAULT_NETWORK.walletUrl
    }

    get faucetURL() {
        return DEFAULT_NETWORK.dcommFaucetUrl
    }
    get img() {
        const color = DEFAULT_NETWORK_ID === 1 ? `black` : `blue`
        return `/img/dcomm_logo_${color}.png`
    }
}
